import { exportPDF, drawDOM, DrawOptions } from '@progress/kendo-drawing'

export const usePdfDownload = () => {
  const dataURItoBlob = (dataURI: string) => {
    const byteString = window.atob(dataURI)
    const arrayBuffer = new ArrayBuffer(byteString.length)
    const int8Array = new Uint8Array(arrayBuffer)
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i)
    }
    const blob = new Blob([int8Array], { type: 'application/pdf' })
    return blob
  }

  const downloadPDF = async (pageContent: HTMLDivElement | null, fileName: string, extraOptions?: DrawOptions) => {
    if (!pageContent) return null

    const options = {
      paperSize: 'A4',
      landscape: true,
      margin: {
        top: '0.5cm',
        left: '0.5cm',
        bottom: '0.5cm',
        right: '0.5cm'
      },
      ...(extraOptions ?? {})
    }

    const group = await drawDOM(pageContent, options)
    const dataUri = await exportPDF(group)
    const parsed = dataUri.replace('data:application/pdf;base64,', '')
    const a = document.createElement('a')
    a.href = window.URL.createObjectURL(dataURItoBlob(parsed))
    a.download = fileName
    a.click()
  }

  return {
    downloadPDF
  }
}
